module.exports = __webpack_public_path__ + "img/133.10.8af14caf.png";